import React from 'react'
// components
import { ReduxInput } from 'components/FormElements'
// utils
import { required } from 'utils/validators'

interface Props {
  field: string
}

const Confirmation: React.FC<Props> = ({ field }) => {
  return (
    <>
      <ReduxInput id={field} validate={required} label='Title' name={`${field}.title`} />
      <ReduxInput multiline validate={required} label='Message' name={`${field}.message`} />
    </>
  )
}

export default Confirmation
